
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-centre",
      function () {
        return require("private-next-pages/help-centre/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-centre"])
      });
    }
  